var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _c("div", { staticClass: "container-fluid xyz" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "admin-page-content" }, [
          _c("div", { class: _vm.alertClass, attrs: { id: "success-alert" } }, [
            _c("strong", [_vm._v(" " + _vm._s(_vm.alertMessage) + " ")])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "forms-container add_user_forms_container" },
            [
              _c(
                "div",
                { staticClass: "row no-margin" },
                [
                  _c("div", { staticClass: "col-12 forms-block" }, [
                    _c(
                      "div",
                      { staticClass: "col-9 paddingleft0" },
                      [
                        _c("b-form-radio-group", {
                          attrs: {
                            options: _vm.forTypeOption,
                            name: "forType"
                          },
                          model: {
                            value: _vm.forType,
                            callback: function($$v) {
                              _vm.forType = $$v
                            },
                            expression: "forType"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _vm.forType == "customer"
                    ? [
                        _c("div", { staticClass: "col-12 forms-block" }, [
                          _vm._m(1),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-9 paddingleft0" },
                            [
                              _c("v-select", {
                                attrs: {
                                  name: "customerId",
                                  id: "customerId",
                                  label: "text",
                                  filterable: true,
                                  options: _vm.customerArr,
                                  clearable: false,
                                  placeholder: "Select Customer"
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.onChnageCustomer()
                                  }
                                },
                                model: {
                                  value: _vm.customerId,
                                  callback: function($$v) {
                                    _vm.customerId = $$v
                                  },
                                  expression: "customerId"
                                }
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "requiredstar" }, [
                                _vm._v("*")
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "text-danger" }, [
                                _vm._v(_vm._s(_vm.customerError))
                              ])
                            ],
                            1
                          )
                        ])
                      ]
                    : [
                        _c("div", { staticClass: "col-12 forms-block" }, [
                          _vm._m(2),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-9 paddingleft0" },
                            [
                              _c("v-select", {
                                staticClass: "multi-select-list",
                                attrs: {
                                  multiple: "",
                                  name: "userId",
                                  id: "userId",
                                  label: "text",
                                  filterable: true,
                                  options: _vm.userArr,
                                  clearable: false,
                                  placeholder: "Select User"
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.onChnageCustomer()
                                  }
                                },
                                model: {
                                  value: _vm.userId,
                                  callback: function($$v) {
                                    _vm.userId = $$v
                                  },
                                  expression: "userId"
                                }
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "requiredstar" }, [
                                _vm._v("*")
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "text-danger" }, [
                                _vm._v(_vm._s(_vm.userError))
                              ])
                            ],
                            1
                          )
                        ])
                      ]
                ],
                2
              ),
              _vm._v(" "),
              _vm._m(3),
              _vm._v(" "),
              _c("div", { staticClass: "clearfix" }),
              _vm._v(" "),
              _c("div", { staticClass: "row clearfix" }),
              _vm._v(" "),
              _c("div", { staticClass: "button-demo" }, [
                _c("input", {
                  staticClass: "btn btn-primary my-1 ms-2",
                  attrs: {
                    id: "addBenifitBtn",
                    disabled: _vm.disableButtons.save,
                    type: "submit"
                  },
                  domProps: { value: _vm.buttonNames.save },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.generateApplicationLink()
                    }
                  }
                }),
                _vm._v(" "),
                _c("input", {
                  staticClass: "btn btn-primary my-1 ms-2",
                  attrs: { type: "submit", value: "Copy Android Link" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.copyAndroidLink()
                    }
                  }
                })
              ])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("app-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header-top-container" }, [
      _c("div", { staticClass: "page-name", staticStyle: { width: "100%" } }, [
        _vm._v("Mobile Application")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("Customer :")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("User :")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row clearfix" }, [
      _c("div", { staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12" }, [
        _c(
          "div",
          { staticClass: "alert alert-danger", attrs: { id: "alertError" } },
          [_c("strong", { staticClass: "error", attrs: { id: "errorMsg" } })]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0f24baa2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f24baa2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileApplicationMaster/MobileApplication.vue
// module id = null
// module chunks = 